import { BufferGeometry, Line, LineBasicMaterial, MathUtils, Vector3 } from 'three'

export default class Connection {
	private readonly delay: number
	private readonly p1: Vector3
	private readonly p2: Vector3
	private readonly sub: Vector3
	private readonly subTemp: Vector3
	private readonly mesh: Line<BufferGeometry, LineBasicMaterial>

	constructor(material, parent, p1, p2) {
		this.delay = Math.random() * 0.25
		this.p1 = p1.clone()
		this.p2 = p2.clone()
		this.sub = p2.clone().sub(p1)
		this.subTemp = this.sub.clone()
		const points = []
		points.push(this.p1)
		points.push(this.p2)
		const geometry = new BufferGeometry().setFromPoints(points)
		this.mesh = new Line(geometry, material)
		parent.add(this.mesh)
	}

	update(elapsed) {
		const duration = 1 - this.delay
		const mappedElapsed = MathUtils.clamp((elapsed - this.delay) * (1 / duration), 0, 1)
		this.subTemp.copy(this.sub)
		this.subTemp.multiplyScalar(mappedElapsed)
		this.subTemp.add(this.p1)
		// @ts-ignore
		this.mesh.geometry.attributes.position.array[3] = this.subTemp.x
		// @ts-ignore
		this.mesh.geometry.attributes.position.array[4] = this.subTemp.y
		// @ts-ignore
		this.mesh.geometry.attributes.position.array[5] = this.subTemp.z
		this.mesh.geometry.attributes.position.needsUpdate = true
	}
}
